module.exports = __webpack_public_path__ + "static/media/Team-Wei.7bde8f67.jpg";